module.exports = __webpack_public_path__ + "static/img/e551c323713b86ce9d5c28fad7bc33c5.48626d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/e551c323713b86ce9d5c28fad7bc33c5.jpg
// module id = 69bI
// module chunks = 4